import { c as _c } from "react/compiler-runtime";
import styles from "./ErrorMessage.module.scss";
import { useFailureMessage } from "../../../shared/failureToast";
export const ErrorMessage: React.FC<{
  children?: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  const failureMessage = useFailureMessage();
  const t1 = children ?? `${failureMessage}.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={styles.container}>{t1}</div>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};